<template>
  <div class="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6" data-testid="login-prompt">
    <h2 class="text-lg font-semibold text-blue-900 mb-2">Sign in to access integrations</h2>
    <p class="text-blue-700 mb-4">To view and manage your integrations, please sign in to your Zight account.</p>
    <div class="flex gap-3">
      <a :href="loginUrl" class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors" data-testid="sign-in-button"> Sign In </a>
      <a
        :href="signupUrl"
        class="bg-white text-blue-600 border border-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition-colors"
        data-testid="create-account-button"
      >
        Create Account
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useSettingsStore } from '@/store/useSettingsStore';
import { storeToRefs } from 'pinia';

const settingsStore = useSettingsStore();
const { loginUrl, signupUrl } = storeToRefs(settingsStore);
</script>
